import React from 'react'
import { withIcon } from '../../withIcon'

function UserCircledIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="4.5" y="4.5" width="15" height="15" rx="7.5" stroke={color}/>
      <path d="M7.53979 18.6481C7.81816 16.7007 9.71117 15.1941 12.005 15.1941C14.2731 15.1941 16.1493 16.6671 16.4602 18.5828C15.1844 19.4758 13.6299 20 11.9526 20C10.3166 20 8.79751 19.5013 7.53979 18.6481Z" fill={color}/>
      <path d="M14.6305 11.0691C14.6305 12.5189 13.4552 13.6941 12.0055 13.6941C10.5557 13.6941 9.38046 12.5189 9.38046 11.0691C9.38046 9.61937 10.5557 8.44412 12.0055 8.44412C13.4552 8.44412 14.6305 9.61937 14.6305 11.0691Z" fill={color}/>
    </svg>
  )
}

export default withIcon(UserCircledIcon)
